import type { SubscriptionBadge } from "../hooks/useAccountTypes";

const subscriptionBadgeDisplayNames: Record<SubscriptionBadge, string> = {
  custom: "Custom Plan",
  pro: "Pro",
  edu: "Edu",
  studio: "Studio",
  individual: "Solo",
  basic: "Basic",
  guest: "Guest",
};

export function getSubscriptionBadgeDisplayName(badge: SubscriptionBadge | undefined): string {
  if (badge === undefined) {
    return "";
  }
  return subscriptionBadgeDisplayNames[badge] ?? badge;
}
